import { render, staticRenderFns } from "./AppGoogleSearch.vue?vue&type=template&id=4d6864c5&scoped=true&"
import script from "./AppGoogleSearch.vue?vue&type=script&lang=js&"
export * from "./AppGoogleSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d6864c5",
  null
  
)

export default component.exports